import axios from 'axios';
import { azaStageazaPath } from '../utilities/UrlPaths';

export const UPDATE_AUCTION = 'AUCTIONS/UPDATE_AUCTION';
export const VERIFY_AUCTION = 'AUCTIONS/VERIFY_AUCTION';

const initialState = {};

export default (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_AUCTION:
      return {
        ...state,
        ...action.data
      };

    case VERIFY_AUCTION:
      return {
        ...state,
        ...action.data
      };

    default:
      return state;
  }
};

export const updateAuction = data => dispatch => dispatch({
  type: UPDATE_AUCTION,
  data
});

export const verifyAuction = data => async dispatch => {
  const path = azaStageazaPath();
  try {
    const response = await axios.get(`${path}/house/${data}/paymentInfo`);

    dispatch({
      type: VERIFY_AUCTION,
      data: response.data.data,
    });
  } catch (err) {
    console.log(err);
  }
};
